/* ============================================================
   MX MOTORSPORTS – Anfrageformular, Verhalten
   Datei: assets/mxm-anfrage.js
   Gehoert zu sections/mxm-anfrage.liquid und assets/mxm-anfrage.css

   Hier gepflegt wird:
   - MODELLE : die Fahrzeugliste (Baureihe -> Modelle)
   - THEMEN  : die Klartext-Namen fuer ?thema= in der Adresszeile
   ============================================================ */

(function(){
  var root = document.querySelector('.mxm-anfrage');
  if(!root) return;
  var form = root.querySelector('form');
  if(!form) return;

  /* ---- Anlass aus ?thema= in der Adresszeile ----
     Shopify-Liquid kann Query-Parameter nicht lesen, das macht der Browser.
     Neue Themen hier ergaenzen: 'slug-in-der-url': 'Text fuer Kunde und Mail' */
  var THEMEN = {
    /* --- Kategorieseiten --- */
    'motor-getriebe':            'Motor und Getriebe',
    'fahrwerkstechnik':          'Fahrwerkstechnik',
    'leistungssteigerung':       'Leistungssteigerung',
    'service-wartung':           'Service und Wartung',
    'carbon-aerodynamik':        'Carbon und Aerodynamik',
    'restauration':              'Restauration',
    /* --- Detailseiten --- */
    'pleuellager-service':       'Pleuellager-Service',
    'crank-hub-fix-s55':         'Crank Hub Fix für S55',
    'vanos-service':             'Vanos-Service',
    'hinterachsverstaerkung-e46':'E46 Hinterachsverstärkung',
    'dkg-service':               'DKG-Service',
    'automatikgetriebe-service': 'Automatikgetriebe-Service',
    'csl-umbauten-e46':          'CSL-Umbauten am E46',
    'softwaretuning':            'Softwaretuning',
    'abgasanlagen':              'Abgasanlagen',
    /* --- Altlasten: fruehere Slugs, damit alte Links weiter funktionieren --- */
    'crank-hub-fix':             'Crank Hub Fix für S55',
    'hinterachse-e46':           'E46 Hinterachsverstärkung',
    'einbau-abgasanlage':        'Abgasanlagen',
    'fahrwerk-achsvermessung':   'Fahrwerk und Achsvermessung'
  };

  (function(){
    var themaFeld  = document.getElementById('mxm-thema');
    var quelleFeld = document.getElementById('mxm-quelle');
    var banner     = root.querySelector('.mxm-topic');
    if(quelleFeld) quelleFeld.value = window.location.pathname + window.location.search;

    var slug = '';
    try{ slug = new URLSearchParams(window.location.search).get('thema') || ''; }catch(e){}
    if(!slug) return;

    var label = THEMEN[slug] || slug.replace(/-/g,' ').replace(/^./,function(c){ return c.toUpperCase(); });
    if(themaFeld) themaFeld.value = label;
    if(banner){ banner.querySelector('.v').textContent = label; banner.hidden = false; }
  })();

  /* ---- Fahrzeugliste: hier erweitern, wenn Baureihen dazukommen ---- */
  var MODELLE = {
    "E36 (1990–2000)":["318i / 320i / 325i","328i","M3 3.0","M3 3.2","Compact","Anderes E36"],
    "E39 / E38 (1995–2004)":["528i / 530i","540i","M5 E39","7er E38","Anderes"],
    "E46 (1998–2006)":["318i / 320i","325i / 328i","330i","330d","M3","M3 CSL","Anderes E46"],
    "E60 / E63 (2003–2010)":["525i / 530i","535d","545i / 550i","M5 E60","M6 E63","Anderes"],
    "E9x (2005–2013)":["320d","325d","330d","335d","325i / 330i","335i","M3 E90 / E92 / E93","Anderes E9x"],
    "F2x / F3x (2011–2019)":["20d","25d","30d","35d","30i","35i","40i","Anderes F2x / F3x"],
    "F8x (2014–2020)":["M2 F87","M2 Competition","M2 CS","M3 F80","M3 Competition","M4 F82 / F83","M4 Competition","M4 CS / GTS"],
    "G2x / G4x (ab 2018)":["M340i / M440i","M240i","30i / 40i","20d / 30d","Anderes G2x / G4x"],
    "G8x (ab 2021)":["M2 G87","M3 G80 / G81","M3 Competition","M4 G82 / G83","M4 Competition","M3 / M4 CS","Anderes G8x"],
    "X-Modelle":["X3M / X4M","X5M / X6M","X5 / X6 Diesel","Anderes X-Modell"],
    "Mini":["Cooper S","JCW","Anderes Mini"],
    "Anderes Fahrzeug":["Bitte im Anliegen beschreiben"]
  };

  var $ = function(id){ return document.getElementById(id); };
  var baureihe=$('mxm-baureihe'), modell=$('mxm-modell'), getriebe=$('mxm-getriebe'),
      consent=root.querySelector('.mxm-consent--dsgvo'),
      progress=root.querySelector('.mxm-progress');
  if(!baureihe) return;
  var fill=progress.querySelector('.mxm-fill'), counter=progress.querySelector('.mxm-n');

  Object.keys(MODELLE).forEach(function(k){ baureihe.appendChild(new Option(k,k)); });

  baureihe.addEventListener('change', function(){
    modell.innerHTML='';
    var list=MODELLE[baureihe.value];
    if(!list){ modell.disabled=true; modell.appendChild(new Option('Zuerst Baureihe wählen','')); update(); return; }
    modell.disabled=false;
    modell.appendChild(new Option('Bitte auswählen',''));
    list.forEach(function(m){ modell.appendChild(new Option(m,m)); });
    update();
  });

  var chips=Array.prototype.slice.call(root.querySelectorAll('.mxm-chip'));
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      var on=c.getAttribute('aria-pressed')==='true';
      chips.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      c.setAttribute('aria-pressed', String(!on));
      getriebe.value = on ? '' : c.dataset.val;
      update();
    });
  });

  var REQ=['mxm-vorname','mxm-nachname','mxm-mail','mxm-baureihe','mxm-modell','mxm-baujahr','mxm-getriebe','mxm-anliegen'];
  var STEPS={1:['mxm-vorname','mxm-nachname','mxm-mail'],
             2:['mxm-baureihe','mxm-modell','mxm-baujahr','mxm-getriebe'],
             3:['mxm-anliegen']};

  function filled(id){
    var el=$(id); if(!el || !el.value.trim()) return false;
    if(id==='mxm-mail') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim());
    return true;
  }

  function update(){
    var n=REQ.filter(filled).length;
    counter.textContent=n;
    fill.style.width=(n/REQ.length*100)+'%';
    progress.classList.toggle('is-complete', n===REQ.length);
    var activeSet=false;
    Object.keys(STEPS).forEach(function(s){
      var el=root.querySelector('.mxm-step[data-step="'+s+'"]');
      if(!el) return;
      var allDone=STEPS[s].every(filled);
      el.classList.toggle('is-done', allDone);
      el.classList.toggle('is-active', !allDone && !activeSet);
      if(!allDone) activeSet=true;
    });
  }
  form.addEventListener('input', update);
  form.addEventListener('change', update);

  /* ---- Klaviyo: Anmeldung aus dem Browser, nur mit oeffentlichem Key ---- */
  function klaviyoSubscribe(){
    var key  = root.dataset.klaviyoKey;
    var list = root.dataset.klaviyoList;
    var mail = $('mxm-mail').value.trim();
    if(!key || !list || !mail){
      console.warn('[MX] Klaviyo uebersprungen – Key, Listen-ID oder E-Mail fehlt.');
      return Promise.resolve();
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: mail,
                first_name: $('mxm-vorname').value.trim(),
                last_name:  $('mxm-nachname').value.trim(),
                properties: {
                  Baureihe:  baureihe.value,
                  Modell:    modell.value,
                  Baujahr:   $('mxm-baujahr').value.trim(),
                  Motorcode: $('mxm-motor').value.trim(),
                  Quelle:    'Anfrageformular',
                  /* Nachweis der Einwilligung – bei Single Opt-in liegt die
                     Beweislast beim Shop, deshalb wird sie hier mitgeschrieben. */
                  Einwilligung_Zeitpunkt: new Date().toISOString(),
                  Einwilligung_Quelle:    window.location.href,
                  Einwilligung_Art:       'Single Opt-in, aktiv gesetzter Haken im Anfrageformular'
                },
                /* Die Einwilligung gehoert INS Profil, nicht eine Ebene
                   darueber. Lag sie aussen, antwortete Klaviyo mit
                   HTTP 400 "'subscriptions' is not a valid field for the
                   resource 'subscription'". Bitte nicht verschieben. */
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    /* Gibt ein Promise zurueck. Wichtig: Der Browser schickt wegen des
       revision-Headers zuerst eine Vorabanfrage (OPTIONS) und erst danach
       den POST. Wuerde das Formular sofort absenden, bricht der Seitenwechsel
       beides ab und in Klaviyo kommt nichts an. Deshalb wartet das Absenden
       unten auf dieses Promise. */
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(key), {
      method:'POST',
      headers:{'Content-Type':'application/json','revision':'2026-07-15'},
      body: JSON.stringify(body),
      keepalive: true,
      mode: 'cors'
    }).then(function(res){
      if(res.ok || res.status===202){
        console.log('[MX] Klaviyo: Anmeldung uebermittelt (HTTP '+res.status+')');
        return;
      }
      return res.text().then(function(t){
        console.error('[MX] Klaviyo hat abgelehnt – HTTP '+res.status+': '+t);
      });
    }).catch(function(err){
      console.error('[MX] Klaviyo nicht erreichbar:', err);
    });
  }

  var abgeschickt = false;

  form.addEventListener('submit', function(e){
    if($('mxm-website').value){ e.preventDefault(); return; }

    var ok=true;
    REQ.forEach(function(id){
      var el=$(id), wrap=el.closest('.mxm-block');
      var bad=!filled(id);
      if(wrap) wrap.classList.toggle('mxm-invalid', bad);
      if(bad) ok=false;
    });
    var d=$('mxm-dsgvo');
    consent.classList.toggle('mxm-invalid', !d.checked);
    if(!d.checked) ok=false;

    if(!ok){
      e.preventDefault();
      var first=root.querySelector('.mxm-invalid');
      if(first) first.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }

    /* Ohne Newsletter-Haken geht das Formular direkt raus. */
    if(!($('mxm-news') && $('mxm-news').checked)) return;

    /* Mit Haken: Seitenwechsel anhalten, bis Klaviyo geantwortet hat.
       Spaetestens nach 2,5 Sekunden wird trotzdem abgeschickt – die Anfrage
       an Max ist wichtiger als die Newsletter-Anmeldung. */
    if(abgeschickt) return;
    e.preventDefault();

    var btn = form.querySelector('.mxm-submit span');
    var btnText = btn ? btn.textContent : '';
    if(btn) btn.textContent = 'Wird gesendet …';

    var weiter = function(){
      if(abgeschickt) return;
      abgeschickt = true;
      clearTimeout(notbremse);
      if(btn) btn.textContent = btnText;
      form.submit();          /* loest diesen Handler bewusst nicht erneut aus */
    };
    var notbremse = setTimeout(function(){
      console.warn('[MX] Klaviyo hat nicht rechtzeitig geantwortet – Anfrage geht trotzdem raus.');
      weiter();
    }, 2500);

    klaviyoSubscribe().then(weiter, weiter);
  });

  update();
})();

/* ENDE – diese Zeile muss nach dem Einfuegen sichtbar sein, sonst ist die Datei abgeschnitten */
